<template>
  <base-modal
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    :ok-title="btnTitle"
    hide-footer
    cancel-title="Cancel"
    cancel-variant="light"
    footer-class="justify-between"
  >
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
        <div class="flex">
          <validation-provider
            name="First name"
            rules="alpha_spaces|required"
            v-slot="validationContext"
            class="mr-2 w-full"
          >
            <div class="mb-4"><label for="firstName" class="block text-[13px] font-medium text-ink mb-1.5">First name *</label>
              <input id="firstName"
                type="text"
                v-model="form.firstName"
                class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
              <span class="text-xs text-[#e53935] mt-1 block" v-if="validationContext.errors[0]">{{ validationContext.errors[0] }}</span>
            </div>
          </validation-provider>
          <validation-provider
            name="Фамилия"
            rules="alpha_spaces|required"
            v-slot="validationContext"
            class="ml-2 mr-2 w-full"
          >
            <div class="mb-4"><label for="lastName" class="block text-[13px] font-medium text-ink mb-1.5">Last name *</label>
              <input id="lastName"
                type="text"
                v-model="form.lastName"
                class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
              <span class="text-xs text-[#e53935] mt-1 block" v-if="validationContext.errors[0]">{{ validationContext.errors[0] }}</span>
            </div>
          </validation-provider>
        </div>

        <div class="flex">
          <div class="mb-4 mr-2 w-full"><label for="email" class="block text-[13px] font-medium text-ink mb-1.5">E-mail</label>
            <input id="email"
              type="text"
              disabled
              v-model="form.email"
              class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
          </div>
        </div>
        <br>
        <button type="submit" class="w-full rounded-3xl bg-primary border-none px-[30px] py-3 text-base text-white tracking-[0.03em] hover:opacity-85 transition-opacity cursor-pointer">
          Save
        </button>
      </form>
    </validation-observer>
    <button type="submit" class="w-full rounded-3xl bg-[#f4f5fa] border-none px-[30px] py-3 text-base text-ink tracking-[0.03em] hover:bg-[#e2e4ed] transition-colors cursor-pointer mt-2" @click="hideModal">
      Cancel
    </button>
  </base-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    item: [Object]
  },
  data () {
    return {
      form: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        onboardingComplete: true
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    title () {
      if (this.item) {
        return 'Edit profile'
      } else {
        return 'Edit profile'
      }
    },
    btnTitle () {
      if (this.item) {
        return 'Save'
      } else {
        return 'Save'
      }
    }
  },
  methods: {
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    submit () {
      const { form } = this
      this.$store.dispatch('UPDATE_PROFILE', { form, id: this.item.id }).then((response) => {
        this.submitted = true
        this.$emit('update')
        this.$store.dispatch('GET_USER')
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
      }, error => {
        console.error('Profile update failed:', error)
      })
    },
    resetModal () {
      this.form.firstName = null
      this.form.lastName = null
      this.form.email = null
      this.form.phone = null
      this.form.onboardingComplete = true
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.form.firstName = this.item.firstName
        this.form.lastName = this.item.lastName
        this.form.email = this.item.email
        this.form.phone = this.item.phone ? this.item.phone : null
        this.form.onboardingComplete = this.item.onboardingComplete ? this.item.onboardingComplete : true
      }
      this.$refs['modal'].show()
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>
